import { isValidDate, newDate, toISODateFormat } from '~/lib/utils/datetime_utility';

/**
 * Groups commits by their authored date (day).
 * @param {Array} commits - Array of commit objects with committedDate
 * @returns {Array} Array of objects with day (ISO date string) and commits
 */
export function groupCommitsByDay(commits) {
  if (!commits?.length) return [];

  const groupedMap = new Map();

  for (const commit of commits) {
    // Git permits commit timestamps with years outside JS Date's ±275,760 range
    const date = newDate(commit.committedDate);
    const day = isValidDate(date) ? toISODateFormat(date) : commit.committedDate;

    if (!groupedMap.has(day)) groupedMap.set(day, { day, commits: [] });

    groupedMap.get(day).commits.push(commit);
  }

  return [...groupedMap.values()];
}
